export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11246.0e4e8639.jpg";